























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary } from '@/entities';
import { AppConstants as _app } from '@/shared/app.constants';
import LogFrameComponent from "./Components/Logframework.vue";
import ProjectMonitoringComponent from "./Components/PMP.vue";
import AmendmentSummary from './Summary.vue';

const namespace: string = "grantAmendment";

@Component({
    components: {
        LogFrameComponent,
        ProjectMonitoringComponent,
        AmendmentSummary
    }
})
export default class LogframeworkComponent extends Vue {

    @Action("updateSubMenu", { namespace }) updateKey: any;
    @Getter("indicators", { namespace }) indicators: any;
    @Prop() subMenu!: any;
    @Prop() data!: any;
    @Prop() schema!: any;
    @Prop() mapping!: any;
    @Prop() readOnly: boolean;
    @Prop() isDirty!: boolean;
    @Prop({ default: true }) allowCustomIndicator: boolean;
    @Prop() GrantInfo!: any;
    @Prop() grantAmendment: any;
    logframeKey: number = 0;
    @Prop() amendmentDtlInfo: any;
    @Prop() userType?: number;
    auditor= _app.UserType.Auditor;

    /**mounted function */
    mounted() {
        let selectedSubKey = 'logFramework';
        if (this.$route.params.section === 'logFramework' && this.$route.hash) {
            selectedSubKey = this.$route.hash.substr(1);
        }
        this.$emit('submenuChanged', { key: 'logFramework', subMenu: selectedSubKey });
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.$emit('submenuChanged', { key: 'logFramework', subMenu: key });
    }

    get subSchema() {
        //return this.subMenu?.properties[this.subKey];
        return this.schema.properties.logFramework;
    }

    /** change event */
    showChange(e) {
        this.$emit("input", true);
        // console.log('"change" event', e)
    }

    /** watch state and update the variable */
    @Watch("data")
    onDataChanged(value: any, oldValue: any) {
        if (!this.data.logframework) {
            this.data.logframework = [];
        }
        this.logframeKey += 1;
    }

    @Watch("subKey")
    onSubKeyChanged(value: any) {
        this.logframeKey += 1;

        // reset scroll bar to top
        if (this.$refs.logFrame) {
            this.$refs.logFrame["scrollTop"] = 0;
        }
    }

}
